module.exports = __webpack_public_path__ + "da02ac46cf6b9b0b5582a1e06c4a89b6.svg";